package one.healthium.db.dao

import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import kotlinx.coroutines.Deferred
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flatMapLatest
import kotlinx.coroutines.flow.flow
import kotlinx.coroutines.withContext
import one.healthium.base.coroutines.IO
import one.healthium.db.AppDatabase
import one.healthium.db.DailyTaskEntity

class DailyTasksDao(
    private val db: Deferred<AppDatabase>
) {
    fun getDailyTaskByDate(date: String): Flow<List<DailyTaskEntity>> {
        return flow { emit(db.await()) }
            .flatMapLatest { it.dailyTasksQueries.selectTasksByDate(date).asFlow() }
            .mapToList(Dispatchers.IO)
    }

    suspend fun insertDailyTasks(entities: List<DailyTaskEntity>) {
        withContext(Dispatchers.IO) {
            val appDatabase = db.await()
            appDatabase.transaction {
                entities.forEach {
                    appDatabase.dailyTasksQueries.insertTask(it)
                }
            }
        }
    }

    suspend fun incrementCompletionCount(id: String) {
        withContext(Dispatchers.IO) {
            db.await().dailyTasksQueries.incementTaskCompletionCount(id)
        }
    }

    suspend fun clearAllCompletionCount() {
        withContext(Dispatchers.IO) {
            db.await().dailyTasksQueries.clearAllCompletionCounts()
        }
    }
}
